import { render, staticRenderFns } from "./EligibilityBanner.vue?vue&type=template&id=321a0a37"
import script from "./EligibilityBanner.vue?vue&type=script&lang=ts"
export * from "./EligibilityBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports